// Дата в формате YYYY-MM-DD
export const REGEX_API_DATE_ISO = /^\d{4}-\d{2}-\d{2}$/;

// Год в формате YYYY
export const REGEX_YEAR = /^\d{4}$/;
